"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var User = __importStar(require("../../Actions/User"));
var CountdownTimer_1 = __importDefault(require("../../Components/CountdownTimer"));
function RequestPage(props) {
  var _this = this;
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var _a = react_1.default.useState(null),
    requestResult = _a[0],
    setRequestResult = _a[1];
  var _b = react_1.default.useState(0),
    endTime = _b[0],
    setEndTime = _b[1];
  var onFinish = function onFinish(values) {
    return __awaiter(_this, void 0, void 0, function () {
      var username, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            username = values.username;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            AppActions.setLoading(true);
            return [4 /*yield*/, User.forgotPasswordRequest({
              username: username
            })];
          case 2:
            _a.sent();
            setEndTime(new Date().getTime() + 2 * 60 * 1000);
            setRequestResult(true);
            return [3 /*break*/, 5];
          case 3:
            ex_1 = _a.sent();
            console.log('EX', ex_1);
            setRequestResult(false);
            return [3 /*break*/, 5];
          case 4:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };

  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };
  var disableInput = requestResult === true;
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement("div", {
    className: "content"
  }, react_1.default.createElement("h2", {
    style: {
      marginBottom: 10
    }
  }, "\u5FD8\u8A18\u5BC6\u78BC"), requestResult === true && react_1.default.createElement("div", {
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u6210\u529F"), react_1.default.createElement("p", null, "\u8ACB\u5230\u60A8\u7533\u8ACB\u7684\u4FE1\u7BB1\u9EDE\u64CA\u8A8D\u8B49\u9023\u7D50, \u4EE5\u4FBF\u91CD\u8A2D\u5BC6\u78BC!")), requestResult === false && react_1.default.createElement("div", {
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u5931\u6557"), react_1.default.createElement("p", null, "\u8ACB\u6C42\u5931\u6557, \u8ACB\u91CD\u65B0\u5617\u8A66\u4E00\u6B21")), react_1.default.createElement(antd_1.Form, {
    layout: "vertical",
    name: "register",
    onFinish: onFinish,
    onFinishFailed: onFinishFailed
  }, react_1.default.createElement(antd_1.Form.Item, {
    label: "EMAIL",
    name: "username",
    rules: [{
      required: true,
      message: '請輸入EMAIL!'
    }]
  }, react_1.default.createElement(antd_1.Input, {
    disabled: disableInput
  })), react_1.default.createElement(CountdownTimer_1.default, {
    endTimeMs: endTime,
    renderText: function renderText(secRemaining) {
      return "\u8ACB\u65BC " + secRemaining + " \u79D2\u5167\u5B8C\u6210\u8A8D\u8B49";
    },
    style: {
      textAlign: 'right'
    }
  }, react_1.default.createElement(antd_1.Form.Item, {
    style: {
      textAlign: 'right'
    }
  }, react_1.default.createElement(antd_1.Button, {
    type: "primary",
    htmlType: "submit"
  }, "\u50B3\u9001\u8A8D\u8B49\u4FE1"))))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n  }\n"], ["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n  }\n"])));
exports.default = RequestPage;
var templateObject_1;